import {
  card_stack_default
} from "./chunk-VNURG7ES.js";

// src/layouts/card-stack/index.ts
var card_stack_default2 = card_stack_default;

export {
  card_stack_default2 as card_stack_default
};
